import { render } from "./StaticImageTwo.vue?vue&type=template&id=b7daaeb2"
import script from "./StaticImageTwo.vue?vue&type=script&lang=js"
export * from "./StaticImageTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__